export const LIB_UI_ACTIVITY_DETECTED = 'LIB_UI_ACTIVITY_DETECTED';
export const LIB_UI_CLEAR_LOCK_ERROR = 'LIB_UI_CLEAR_LOCK_ERROR';
export const LIB_UI_SET_LOCK = 'LIB_UI_SET_LOCK';

export const PUSH_PIN_SETTINGS_CHANGE = 'PUSH_PIN_SETTINGS_CHANGE';
